/**
 * POST JSON public Admin (forgot / complete password reset).
 * Pas de Bearer, pas de refresh, pas de log du body.
 */

function extractApiErrorMessage(errorData, status) {
  if (typeof errorData?.detail === 'string' && errorData.detail.trim()) {
    return errorData.detail.trim();
  }
  if (typeof errorData?.message === 'string' && errorData.message.trim()) {
    return errorData.message;
  }
  if (errorData?.details?.[0]?.message) {
    return errorData.details[0].message;
  }
  if (errorData?.error?.message) {
    return errorData.error.message;
  }
  if (typeof errorData?.error === 'string') {
    return errorData.error;
  }
  return `Erreur ${status}`;
}

export async function publicJsonPost(baseURL, endpoint, payload) {
  const url = `${baseURL}${endpoint}`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload ?? {}),
  });

  const contentType = response.headers.get('content-type') || '';
  let data = {};
  if (contentType.includes('application/json')) {
    data = await response.json().catch(() => ({}));
  } else {
    const text = await response.text();
    if (text) {
      data = { error: { message: text } };
    }
  }

  if (!response.ok) {
    const error = new Error(extractApiErrorMessage(data, response.status));
    error.status = response.status;
    error.data = data;
    error.code = data?.code || data?.error?.code || undefined;
    error.response = { status: response.status, data };
    throw error;
  }

  return data;
}
